import Swal, { SweetAlertIcon } from "sweetalert2";
import { Message } from "../models/api-response";
import { AbstractControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { resultTransferPoint } from "../models/gift-response";


export async function alertMessage(msgType: SweetAlertIcon, msg: Message): Promise<any> {
  if (msgType == 'success') {

    var res = await Swal.fire({
      title: msg.en,
      //text: msg.th,
      icon: msgType,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      allowOutsideClick: false
    })
    return res.isConfirmed;

  } else {

    var res = await Swal.fire({
      title: msg.en,
      //text: msg.th,
      icon: msgType,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      timer: 3000,
      allowOutsideClick: false
    })
    return res.isConfirmed

  }
}



export async function alertMessageConfirmTransferPoint(msgType: SweetAlertIcon, msg: Message, result: resultTransferPoint): Promise<any> {
  if (msgType == 'success') {

    var res = await Swal.fire({
      title: msg.en,
      html:  `<div class="text-start border-top pt-4">
      <p class="fw-bold">Transfer Point Result</p>
      <p class="text-center border p-2 mt-4">Owner</p>
      <p>${result.ownName}</p>
      <p>Start Point: ${result.ownStartPoint}</p>
      <p>Transfer point: ${result.ownTransferPoint}</p>
      <p>Remain point: ${result.ownRemain}</p> 
      <p class="text-center border p-2 mt-4">Receiver</p>
      <p>${result.recName}</p>
      <p>Start Point: ${result.recStartPoint}</p>
      <p>Transfer point: ${result.recTransferPoint}</p>
      <p>Remain point: ${result.recRemain}</p><div>`,
      icon: msgType,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      allowOutsideClick: false
    })
    return res.isConfirmed;

  } else {

    var res = await Swal.fire({
      title: msg.en,
      icon: msgType,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      timer: 3000,
      allowOutsideClick: false
    })
    return res.isConfirmed

  }
}

export async function alertMessageComfirm(msgType: SweetAlertIcon, msg: string): Promise<any> {

  var res = await Swal.fire({
    title: msg,
    //text: msg.th,
    icon: msgType,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    allowOutsideClick: false
  })
  return res.isConfirmed;
}


export class CustomValidator {
  // Number only validation
  static numeric(control: AbstractControl) {
    let val = control.value;

    if (val === null || val === '') return null;

    if (!val.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) return { 'invalidNumber': true };

    return null;
  }
}

export function S2N(inputString: string): number {
  try {
    let res = Number(inputString.replace(/,/g, ''));
    return res
  } catch (error) {
    return Number(inputString)
  }
}
export function numberWithCommas(x: any) {
  if (x != null) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return x;
  }
}
export function numberWithCommasAndDigit(x: any, y: number) {
  return (x).toFixed(y).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

